var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-group" }, [
    _c("div", { staticClass: "item-name" }, [
      _c("label", [_vm._v("電話番号")]),
      _vm._v(" "),
      _vm.$v.telephoneNumber.$dirty
        ? _c("div", [
            !_vm.$v.telephoneNumber.required
              ? _c("div", { staticClass: "error-text" }, [
                  _vm._v("\n        電話番号を入力してください。\n      ")
                ])
              : _vm._e()
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.$v.telephoneNumber.$model,
          expression: "$v.telephoneNumber.$model"
        }
      ],
      staticClass: "telephone-number",
      class: _vm.status(_vm.$v.telephoneNumber),
      attrs: { type: "number", placeholder: "09012345678" },
      domProps: { value: _vm.$v.telephoneNumber.$model },
      on: {
        change: _vm.changeTelephoneNumber,
        input: function($event) {
          if ($event.target.composing) {
            return
          }
          _vm.$set(_vm.$v.telephoneNumber, "$model", $event.target.value)
        }
      }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5cb43dc4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cb43dc4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/molecules/InputTelephoneNumber.vue
// module id = null
// module chunks = 